
export const stopped = Symbol('stopped');
